import React, { useState, useEffect, useContext } from 'react';
import { LegacyStack } from '@shopify/polaris';
import OrderRow from './OrderRow'
import { OrdersContext } from '../../contexts/Orders'

export default function OrdersTable(props) {
  const orders = useContext(OrdersContext);

  return (
    <div>
    { orders.length ?
      <table className="responsive">
        <thead>
          <tr>
            <th className="order_number">Order</th>
            <th className="date">Date</th>
            <th className="payment_status">Payment Status</th>
            <th className="fulfillment_status">Status</th>
            <th className="total">Total</th>
          </tr>
        </thead>
        <tbody>
          { orders.map((order, index) => (<OrderRow key={`${order.id}_${index}`} item={order} />))}
        </tbody>
      </table>
    : <span>You do not have any orders yet.</span> }
    </div>
  )
}
